import { iots } from '@code-expert/prelude';
import { query } from '/imports/modules/Routing';

const securitySectionKeys = {
  manage: null,
  add: null,
};

export type SecuritySection = keyof typeof securitySectionKeys;

export const securitySectionQuery = query(
  iots.exact(iots.partial({ section: iots.keyof(securitySectionKeys) })),
);
